Vue.asyncComponent('cms-dashboard-seo-meta-descriptions', {
    props: {
        title: {
            type: String,
            default: '',
        },
        statusValue: {
            type: String,
            default: '',
        },
        statusDescription: {
            type: String,
            default: '',
        },
        pages: {
            type: Array,
            default: () => [],
        },
        emptyText: {
            type: String,
            default: '',
        },
    },
}, 'cms/dashboard/live/cms-dashboard-seo-meta-descriptions.html');
